'use client';

import { useEffect, useState } from 'react';
import { useI18n } from 'next-localization';

import { cn } from '@/lib/utils';
import { NeuCheckbox } from '@hcahealthcaredpx/neutron-react';

import { useListingContext } from '../../hooks';
import styles from '../../listing.module.css';

export const NewPatientOnlineBookingFilter = (): JSX.Element => {
  const { t } = useI18n();

  const { showAcceptingNewPatientsOnly, toggleShowAcceptingNewPatientsOnly } = useListingContext();
  // The useState and useEffect are used to ensure the checkbox reflects the current state from context
  // This is necessary because NeuCheckbox may not re-render correctly when the prop changes directly
  // and the filters aren't populated from url params on initial load without this fix.
  const [checked, setChecked] = useState(false);
  useEffect(() => {
    setChecked(showAcceptingNewPatientsOnly);
  }, [showAcceptingNewPatientsOnly]);

  return (
    <div className={cn('align-self-start w-100 py-4', styles.filtersWrapperWithBorder)}>
      <NeuCheckbox
        label={t('OAS.Profile.Details.NewPatientOnlineBooking')}
        checked={checked}
        onNeuChange={() => toggleShowAcceptingNewPatientsOnly()}
      />
    </div>
  );
};
